export * from './paginatedResponseMock'
export type MockFn<T = {}> = (extend?: Partial<T>) => T

export const referenceDate = new Date(1536651812414) // Tue Sep 11 2018 07:43:32 GMT+0000
